import { useEffect } from 'react';
import { eventBus, type HubEvents } from './eventBus';

export function useHubEvent<K extends keyof HubEvents>(name: K, handler: (payload: HubEvents[K]) => void) {
  useEffect(() => {
    eventBus.on(name, handler as never);
    return () => eventBus.off(name, handler as never);
  }, [name, handler]);
}
